import { render, staticRenderFns } from "./achievement.vue?vue&type=template&id=bca11e18&scoped=true&"
import script from "./achievement.vue?vue&type=script&lang=js&"
export * from "./achievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca11e18",
  null
  
)

export default component.exports